import React from "react";
import "../../../../../App.css";
import "../../../../_Shared/utility.css";
import "./HCP-testimonials.css";
import "../Patients/Patient-testimonials.css";
import { TestimonalQuote } from "../../../../TestimonalQuote/TestimonalQuote";
import { FRBanner } from "../../../../Banner/Banner";
import { Helmet } from "react-helmet-async";
import { cdn } from "../../../../../consts/cdn";
import { JwPlayer } from "../../../../JwPlayer/JwPlayer.js";

//images
const VideoThumbnail1 = cdn.images + "Testimonials/HCP/Thumbnail1.jpg";
const VideoThumbnail2 =
  cdn.images + "Testimonials/HCP/HCPTestimonials_Thumbnail1_EU.jpg";
const VideoThumbnail3 =
  cdn.images + "Testimonials/HCP/HCPTestimonials_Thumbnail2_EU.jpg";
const BannerDesktop =
  cdn.images + "Testimonials/HCP/Banner-Desktop-Compressed.jpg";
const BannerMobile = cdn.images + "Testimonials/HCP/Banner-Mobile.jpg";

function HCPTestimonial() {
  return (
    <>
      <Helmet>
        <title>
          vNOTES – Advanced Minimally Invasive Gynecologic Procedures
        </title>
        <meta
          name="description"
          content="vNOTES (vaginal natural orifice transluminal endoscopic surgery) workshops provide a comprehensive understanding of procedural steps and instrumentation used…"
        />
      </Helmet>
      <div className="testimonial">
        <FRBanner
          imgdesktop={BannerDesktop}
          imgmobile={BannerMobile}
          bold1="TÉMOIGNAGES"
          text1="Professionnels de santé"
          color="#365B7E"
          openSans="true"
        />
        <div className="content">
          <div className="hcp__video-container hcp__video-container--1">
            <div className="testimonial__content--1">
              <JwPlayer
                file="https://ep-appliedmediaservice-ammedia-mediakind.westus2.streaming.mediakind.com/3b0e820b-1207-4b12-aec9-6d9ac7159df6/vNOTES as Featured on ACOG TV.ism/manifest(format=m3u8-cmaf)"
                title="Le vNOTES présenté sur ACOG TV*"
                image={VideoThumbnail1}
              ></JwPlayer>
              <div className="video-description">
                <p>Le vNOTES présenté sur ACOG TV<sup>*</sup> <br />
                  <small className="note">
                    * La vidéo étant en anglais, pour obtenir la traduction en français, veuillez&nbsp;  
                    <a href="/fr/contactus" aria-label="Contact us for French translation">nous contacter</a>.
                  </small>
                  </p>
              </div>
            </div>
          </div>

          <div className="hcp__video-container hcp__video-container--2">
            <div className="testimonial__content--2">
              <JwPlayer
                file="https://ep-appliedmediaservice-ammedia-mediakind.westus2.streaming.mediakind.com/47fec83b-a4a2-4a43-b591-2144975dd7b0/661418-FR-A vNOTES A Surgeon's P.ism/manifest(format=m3u8-cmaf)"
                title="vNOTES : le point de vue d'un chirurgien sur la douleur post-opératoire"
                image={VideoThumbnail2}
              ></JwPlayer>
              <div className="video-description">
                <p>vNOTES : le point de vue d'un chirurgien sur la douleur post-opératoire</p>
              </div>
            </div>

            <div className="testimonial__content--2">
              <JwPlayer
                file="https://ep-appliedmediaservice-ammedia-mediakind.westus2.streaming.mediakind.com/e632bb30-b60a-43bb-a2cd-096b5cf1f575/675699-FR-A vNOTES - A Vaginal S.ism/manifest(format=m3u8-cmaf)"
                title="vNOTES : la préférence d'un chirurgien vaginaliste"
                image={VideoThumbnail3}
              ></JwPlayer>
              <div className="video-description">
                <p>vNOTES : la préférence d'un chirurgien vaginaliste</p>
              </div>
            </div>
          </div>

          <div className="hcp__div-review">
            <TestimonalQuote
              quote="We have found that with vNOTES patients recover more quickly and have less postoperative pain. Additionally, the OR time for the procedure is shorter and results in fewer postoperative complications."
              quote2={"« Nous avons constaté qu'avec le vNOTES, les patientes se rétablissent plus rapidement et ressentent moins de douleurs post-opératoires. En outre, la durée de l'intervention au bloc opératoire est plus courte et entraîne moins de complications post-opératoires. »"}
              name="Dr. Jan Baekelandt,&nbsp;"
              credential="PhD"
              location="Belgique"
            />
          </div>

          <div className="hcp__div-review">
            <TestimonalQuote
              quote="vNOTES has helped my patients return to everyday life quickly by significantly reducing their postoperative pain. Additionally, patients appreciate not having any visible scars because they feel better about their appearance after surgery."
              quote2={"« Le vNOTES a aidé mes patientes à reprendre leur vie quotidienne en réduisant de manière significative leurs douleurs post-opératoires. En outre, les patientes apprécient de ne pas avoir de cicatrice visible car elles se sentent mieux dans leur peau après l'opération. »"}
              name="Dr. Grover May"
              location="États-Unis"
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default HCPTestimonial;
